'use strict';

function parse(reader) {
    reader.readUInt8('data.params.tls_enabled', value => value === 1);
    reader.readUInt8('data.params.username_auth_enabled', value => value === 1);
    reader.readString(64, 'data.params.proxy_addr');
    reader.readString(33, 'data.params.client_id');
    reader.readString(32, 'data.params.username');
    reader.readString(16, 'data.params.password');
    reader.readUInt16LE('data.params.proxy_port');
    reader.readUInt32LE('data.params.timeout');
    reader.readUInt32LE('data.params.keep_alive');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/mqtt-config-parser.js